<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0 d-flex align-items-center">
                        <h5>{{ headerTitle }}</h5>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Titulo</label>
                                    <div class="col-md-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="form.state.titulo"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Usuario</label>
                                    <div class="col-md-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="form.state.user.fullName"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Body</label>
                                    <div class="col-md-9">
                                        <textarea
                                            class="form-control"
                                            rows="3"
                                            v-model="form.state.body"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-md-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="form.state.read ? 'Leida' : 'No leida'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </WindowLayout>
</template>

<script setup>
import { defineProps, onMounted } from 'vue';

import WindowLayout from '@/layouts/Window.layout.vue';

import useNotifications from './services/useNotifications';
import { useNotificationsDetail } from './composables/useNotificationsDetail';

const props = defineProps({
    title: { type: String, default: 'Notificaciones' },
    headerTitle: { type: String, default: 'Notificación' },
    urlRead: { type: String, required: false },
    urlCreate: { type: String, required: false },
    urlUpdate: { type: String, required: false },
    item: Object,
});

const service = useNotifications();
const { ...form } = useNotificationsDetail();

onMounted(async () => {
    if (props.item) {
        await Promise.all([service.getNotification(props.item.id)]);
        if (service.notification) {
            form.setState(service.notification.value);
        }
    }
});
</script>
